import React, { useState } from 'react';
import { updateCommunityHome } from '../services/tenantService';

export default function CommunityHomeEditor({ tenant, onSaved }) {
  const [text, setText] = useState(tenant.communityHomeText || '');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const save = async (event) => {
    event.preventDefault();
    setSaving(true);
    setMessage('');
    setError('');
    try {
      const { data } = await updateCommunityHome(tenant._id, text);
      onSaved(data);
      setMessage('Community home text saved.');
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to save community home text. Please retry.');
    } finally {
      setSaving(false);
    }
  };
  return (
    <section className="community-home-editor">
      <h3>Community home message</h3>
      <p>Welcome members, explain how to use the portal, or share contact information. This is visible on your community home.</p>
      <form onSubmit={save} className="branding-form">
        <label htmlFor="community-home-text">Community home text</label>
        <textarea id="community-home-text" rows={8} maxLength={10000} value={text}
          disabled={saving} onChange={(event) => setText(event.target.value)} />
        <small>{text.length.toLocaleString()} / 10,000 characters. Plain text; line breaks are preserved. Clear the box to remove the message.</small>
        {error && <p role="alert">{error}</p>}
        {message && <p role="status">{message}</p>}
        <button type="submit" disabled={saving}>{saving ? 'Saving...' : 'Save community home text'}</button>
      </form>
    </section>
  );
}
